var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-full-page" },
    [
      _c(
        "CompassButton",
        _vm._b(
          { on: { click: _vm.primaryAction.action } },
          "CompassButton",
          _vm.primaryAction,
          false
        )
      ),
      _vm._v(" "),
      _vm._l(_vm.secondaryActions, function(action, index) {
        return _c(
          "CompassPlainButton",
          _vm._b(
            {
              key: index,
              attrs: { variant: "neutral" },
              on: { click: action.action }
            },
            "CompassPlainButton",
            action,
            false
          )
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }